import React from "react";

import { useTranslation } from "react-i18next";

import { useLiveWidgetStore } from "@state/hooks/live-widgets";
import LmtLsEventsStore from "@state/stores/side-widgets/LmtLsEventStore";
import classNames from "classnames";
import { observer } from "mobx-react";

export const SideWidgetHeaderTitle = observer(
	(props: { lmtLsStore: LmtLsEventsStore; isMainTitle?: boolean }) => {
		const t = useTranslation().t;
		const widgetStore = useLiveWidgetStore();
		const activeWidget = widgetStore.activeSideWidget;
		const titleClasses = classNames("widget__title", {
			"widget--draggable__title": widgetStore.isWidgetFloating,
			"widget__title--sub": !props.isMainTitle,
		});

		const widgetTitle =
			activeWidget != null
				? `${activeWidget.teamOneName} - ${activeWidget.teamTwoName}`
				: t<string>("COMMON.MEDIA");

		if (props.isMainTitle && activeWidget != null) {
			return (
				<div className={titleClasses} title={t<string>("COMMON.MEDIA")}>
					{t<string>("COMMON.MEDIA")}
				</div>
			);
		}

		return (
			<div className={titleClasses} title={widgetTitle}>
				{widgetTitle}
			</div>
		);
	}
);
